module.exports = __webpack_public_path__ + "static/015-038dd062955d205b71f77fb05f4f9a27.jpg";